<div class="d-flex fd-col jc-start ai-stretch">
  <h4 class="header-top-margin">{{ option.filterMethodConfig.title }}</h4>
  <form [formGroup]="formGroup">
    <mat-radio-group color="primary" class="flex-1" formControlName="radio">
      <ng-container *ngFor="let radioOption of option.filterMethodConfig.options">
        <mat-radio-button  [ngClass]="{ 'option-columns-2': optionsColumns == 2, 'option-columns-3': optionsColumns == 3 }" [value]="radioOption">{{
          radioOption.name
        }}</mat-radio-button>
      </ng-container>
    </mat-radio-group>
  </form>

  <!-- <p> {{ formGroup.value | json }}</p> -->
</div>
